// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.sas-container {
  display: flex;
  flex-direction: column;
  position: relative;
}
.sas-container .sas-input {
  border: 1px solid #808080;
  border-radius: 5px;
  height: 30px;
  padding-left: 8px;
  width: 394px;
}
.sas-container .el-icon-container {
  background-color: white;
  cursor: pointer;
  position: sticky;
  text-align: center;
  top: 0;
}
.sas-container .sas-auto-suggest {
  border-radius: 10px;
  background: #ffffff;
  border: 2px solid #a9a9a9;
  max-height: 400px;
  overflow-x: hidden;
  position: absolute;
  width: 394px;
  display: flex;
  flex-direction: column;
  z-index: 100;
}
.sas-container .sas-auto-suggest .employee-lookup-btn {
  border-radius: 3px;
  align-items: center;
  background-color: transparent;
  border: 0.5px solid grey;
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
.sas-container .sas-auto-suggest .employee-lookup-btn .employee-btn-layout {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.sas-container .sas-auto-suggest .employee-lookup-btn .employee-btn-layout .el-school {
  font-size: "14px";
  font-style: italic;
}
.sas-container .sas-none-found {
  border-radius: 10px;
  background: #ffffff;
  border: 2px solid #a9a9a9;
  max-height: 400px;
  overflow-x: hidden;
  padding: 8px;
  position: absolute;
  text-align: center;
  width: 394px;
  z-index: 1000;
}
.sas-container .sas-none-found .none-found-message {
  border-top: 1px solid #D1D3D4;
  padding-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SimpleAutoSuggest.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AAUJ;AARI;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;AAUR;AAPI;EACI,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;AASR;AANI;ECrBA,mBDsB0B;EACtB,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EAEA,YAAA;AAOR;AALQ;EClCJ,kBDmC8B;EACtB,mBAAA;EACA,6BAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;AAOZ;AALY;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AAOhB;AALgB;EACI,iBAAA;EACA,kBAAA;AAOpB;AACI;EC1DA,mBD2D0B;EACtB,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AACR;AACQ;EACI,6BAAA;EACA,gBAAA;AACZ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.sas-container {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    .sas-input {\n        border: 1px solid $grey3;\n        border-radius: 5px;\n        height: 30px;\n        padding-left: 8px;\n        width: 394px;\n    }\n\n    .el-icon-container {\n        background-color: white;\n        cursor: pointer;\n        position: sticky;\n        text-align: center;\n        top: 0;\n    }\n\n    .sas-auto-suggest {\n        @include borderRadius(10px);\n        background: #ffffff;\n        border: 2px solid #a9a9a9;\n        max-height: 400px;\n        overflow-x: hidden;\n        position: absolute;\n        width: 394px;\n        display: flex;\n        flex-direction: column;\n\n        z-index: 100;\n\n        .employee-lookup-btn {\n            @include borderRadius(3px);\n            align-items: center;\n            background-color: transparent;\n            border: .5px solid grey;\n            display: flex;\n            justify-content: space-between;\n            padding: 8px;\n\n            .employee-btn-layout {\n                display: flex;\n                flex-direction: column;\n                text-align: left;\n\n                .el-school {\n                    font-size: \"14px\";\n                    font-style: italic;\n                }\n            }\n\n        }\n\n    }\n\n    .sas-none-found {\n        @include borderRadius(10px);\n        background: #ffffff;\n        border: 2px solid #a9a9a9;\n        max-height: 400px;\n        overflow-x: hidden;\n        padding: 8px;\n        position: absolute;\n        text-align: center;\n        width: 394px;\n        z-index: 1000;\n\n        .none-found-message {\n            border-top: 1px solid $grey1;\n            padding-top: 8px;\n        }\n\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
